import React, { useEffect, useState } from "react";
import BoxPayGrid from "../BoxPayGrid";
import { useAuth } from "../../context/API_Client";
import { ProductsSchema } from "./productsSchema";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import LoadingLogoPage from "../loadingPage/loadingPage";
import CreateProduct from "./createProduct";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { convertIsoToGivenDateFormat } from "../utils/utils";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../constants/brandings";

function Products(operationPermissions) {
  const {
    getProductDetails,
    getAllModalData,
    getBusinessUnits,
    deleteProduct,
    merchantSettings,
  } = useAuth();
  const [gridData, setGridData] = useState([]);
  const [error, setError] = useState([]);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteCode, setDeleteCode] = useState();
  const [createdUnit, setCreatedUnit] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedVersion, setSelectedVersion] = useState("");

  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [timeZone, setTimeZone] = useState(null);
  const [minimumAmount, setMinimumAmount] = useState(null);
  const [maximumAmount, setMaximumAmount] = useState(null);
  const [businessUnit, setBusinessUnit] = useState(null);
  const [currencyCode, setCurrencyCode] = useState(null);
  const [businessUnitData, setBusinessUnitData] = useState(null);
  const [externalProduct, setExternalProduct] = useState(true);

  const handleOpen = () => {
    setEditing(false);
    setSelectedProduct("");
    setSelectedCode("");
    setSelectedDescription("");
    setMaximumAmount(null);
    setMinimumAmount(null);
    setBusinessUnit(null);
    setCurrencyCode(null);
    setOpen(true);
  };

  const handleClose = (event) => {
    setOpen(false);
  };

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
        setExternalProduct(data?.externalProductManagement);
      },
      function (errorMsg) { }
    );

    getBusinessUnits(
      function (data) {

        setBusinessUnitData(data);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    // getAllModalData(
    //   function (data) {
    //     console.log('data',);

    //     setBusinessUnitData(data?.legalEntities);
    //   },
    //   function (errorMsg) { }
    // );
  }, []);

  useEffect(() => {
    if (timeZone && businessUnitData) {
      getProductDetails(
        function (data) {
          const filteredData = data?.map((rawData) => {
            const epochValue = rawData.timestamp;
            const outputDatetimeStr = epochValue
              ? convertIsoToGivenDateFormat(epochValue, timeZone)
              : null;
            rawData["addedDTime"] = outputDatetimeStr;


            // rawData.businessUnits = businessUnitData.find(
            //   (legalEntity) => legalEntity?.code == rawData?.businessUnits
            // )?.name;
            rawData.businessUnitsCode = businessUnitData.find(
              (legalEntity) => legalEntity?.name == rawData?.businessUnits
            )?.code;
            return rawData;
          });
          setGridData(filteredData);
          setLoading(false);
        },
        function (errorMsg) {
          setError(errorMsg);
        }
      );
    }
  }, [createdUnit, timeZone, businessUnitData]);

  const handleEdit = (data) => {
    setEditing(true);
    setSelectedProduct(data?.name);
    setSelectedCode(data?.code);
    setSelectedDescription(data?.description);
    setSelectedVersion(data?.version);
    setMinimumAmount(data?.minAmount);
    setMaximumAmount(data?.maxAmount);
    setBusinessUnit(data?.businessUnits);
    setCurrencyCode(data?.currencyCode);
    setOpen(true);
  };

  const handleDelete = (code) => {
    setDeleteCode(code);
    setOpenDelete(true);
  };

  const handleDeleteProduct = () => {
    deleteProduct(
      deleteCode,
      function (data) {
        setCreatedUnit(!createdUnit);
        setOpenDelete(false);
        customToast("success", "high", "Product deleted");
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };
  return (
    <>
      {loading ? (
        <div className="content-wrapper" style={{ background: "white" }}>
          <section
            className="content"
            style={{
              top: "50%",
              left: "50%",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : (
        <div className="content-wrapper" style={{ background: "white" }}>
          <section className="content">
            {gridData?.length > 0 ? (
              <>
                <ContentHeader
                  icon={<Inventory2OutlinedIcon sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />}
                  firstHeading="Product Catalogue"
                  secondHeading="Product catalogue are the products or services provided by a business to their customers"
                  buttonPermissions={[operationPermissions?.createProduct]}
                  buttonText={externalProduct ? null : "Add Product"}
                  buttonType="primary"
                  buttonSize="md"
                  buttonVariant="contained"
                  buttonOnclick={handleOpen}
                />
                <div
                  style={{ display: "flex", width: "100%", marginTop: "32px" }}
                >
                  <BoxPayGrid
                    schema={ProductsSchema(
                      handleEdit,
                      handleDelete,
                      operationPermissions,
                      externalProduct
                    )}
                    data={gridData}
                    showCustomizeButton={false}
                  ></BoxPayGrid>
                </div>
                <SmallModal
                  headerText={"Are you sure you want to delete this product?"}
                  subHeaderText={
                    "By deleting this product, you will not be able to see this in the list"
                  }
                  outlinedBtnText={"Cancel"}
                  filledBtnText={"Delete"}
                  outlinedBtnFunction={() => setOpenDelete(false)}
                  filledBtnFunction={handleDeleteProduct}
                  toggleDialog={openDelete}
                  icon={
                    <img src="/assets/routingIcons/ExclamationCircle.svg" />
                  }
                />
              </>
            ) : (
              <div className="routing-root-container">
                <EmptyState
                  image={
                    <Inventory2OutlinedIcon
                      sx={{
                        color: "rgba(201, 201, 204, 1)",
                        height: "120px",
                        width: "120px",
                      }}
                    />
                  }
                  mainText={"Product Catalogue"}
                  subText={
                    "Product catalogue are the products or services provided by a business to their customers"
                  }
                  btnText={externalProduct ? null : "Add Product"}
                  btnFunction={handleOpen}
                  btnPermission={operationPermissions?.createProduct}
                />
              </div>
            )}
          </section>
        </div>
      )}
      {open && (
        <CreateProduct
          open={open}
          onClose={handleClose}
          createdUnit={createdUnit}
          setCreatedUnit={setCreatedUnit}
          selectedProduct={selectedProduct}
          selectedCode={selectedCode}
          selectedDescription={selectedDescription}
          selectedVersion={selectedVersion}
          minAmount={minimumAmount}
          maxAmount={maximumAmount}
          businessUnit={businessUnit}
          currency={currencyCode}
          editing={editing}
        />
      )}
    </>
  );
}

export default Products;
